import { useState } from "react";
import {
  UsersApi,
  UsersApproveUserPostRequest,
  RequestApproveUserRequestWrapper,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiApproveUser = () => {
  const [approveUserResult, setApproveUserResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const approveUsers = async (req: RequestApproveUserRequestWrapper) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersApproveUserPostRequest = {
        wrapperReq: req,
      };
      const api = new UsersApi(config);
      const response = await api.usersApproveUserPost(request);
      setApproveUserResult(response);
      return response;
    } catch (err) {
      setError("ユーザー承認に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { approveUsers, error, isLoading };
};
